export const ruTranslations = {
  langSwitcher: {
    aria: 'Сменить язык',
  },

  nav: {
    calendar: 'Календарь',
    shiftCalendar: 'График смен',
    timestamp: 'Timestamp',
    addSubtractDate: 'Добавить дни',
    dateDifference: 'Разница дат',
    businessDays: 'Рабочие дни',
    ageCalculator: 'Возраст',
    daysUntilDate: 'Сколько дней до',
    weekNumber: 'Номер недели',
    timeZones: 'Часовые пояса',
    timer: 'Таймер',
    pomodoro: 'Помодоро',
    stopwatch: 'Секундомер',
    blog: 'Блог',
  },

  common: {
    dateTools: 'Инструменты для дат',
    copy: 'Копировать',
    copied: 'Скопировано',
    clear: 'Очистить',
    localBadge: 'Локально в браузере',
    faq: 'Вопросы',
    updated: 'Обновлено',
    allBlogPosts: 'Все записи блога',
    hotkeys: {
      label: 'Горячие клавиши',
      space: 'Пробел',
      startPause: 'старт и пауза',
      lap: 'круг',
      reset: 'сброс',
    },
  },

  index: {
    title: 'Бесплатные инструменты для работы с датами',
    description:
      'Быстрые локальные утилиты для работы с датами и временем. Без регистрации, водяных знаков и отправки данных на сервер.',
    tools: [
      {
        title: 'Календарь онлайн',
        description:
          'Смотрите календарь на год или выбранный месяц, меняйте начало недели и включайте номера ISO недель.',
        href: '/kalendar',
      },
      {
        title: 'График смен',
        description:
          'Отметьте рабочие и выходные дни по циклу 2/2, 3/3, сутки через трое или своему простому графику.',
        href: '/grafik-smen',
      },
      {
        title: 'Добавить или вычесть дни',
        description:
          'Прибавьте или вычтите дни, недели, месяцы и годы от выбранной даты. Результат показывает итоговую дату и день недели.',
        href: '/dobavit-dni-k-date',
      },
      {
        title: 'Разница между датами',
        description:
          'Узнайте, сколько дней, недель, месяцев и лет прошло между двумя датами. Счётчик длительности с опцией рабочих дней.',
        href: '/raznica-mezhdu-datami',
      },
      {
        title: 'Рабочие дни между датами',
        description:
          'Посчитайте рабочие дни по обычным выходным или по approved федеральному календарю РФ для пятидневки.',
        href: '/rabochie-dni-mezhdu-datami',
      },
      {
        title: 'Unix timestamp конвертер',
        description:
          'Конвертируйте Unix timestamp в дату и обратно. Текущее время, секунды, миллисекунды, наносекунды и epoch days.',
        href: '/timestamp',
      },
      {
        title: 'Калькулятор возраста',
        description:
          'Посчитайте возраст в годах, месяцах и днях по дате рождения. Показывает общее число прожитых дней.',
        href: '/kalkulyator-vozrasta',
      },
      {
        title: 'Сколько дней до даты',
        description:
          'Выберите будущую или прошедшую дату и сразу увидьте дни, недели и статус: сегодня, прошла или впереди.',
        href: '/skolko-dnej-do-daty',
      },
      {
        title: 'Номер недели',
        description:
          'Введите дату и получите ISO неделю, ISO год и день недели. Или укажите ISO год и неделю, чтобы увидеть диапазон дат.',
        href: '/nomer-nedeli',
      },
      {
        title: 'Конвертер часовых поясов',
        description:
          'Сравните один момент в 2–5 городах и IANA-зонах. Учитывает дату, смещение UTC и переходы на летнее время.',
        href: '/chasovye-poyasa',
      },
      {
        title: 'Таймер',
        description:
          'Запустите обратный отсчёт с часами, минутами и секундами. Вкладка показывает оставшееся время.',
        href: '/timer',
      },
      {
        title: 'Помодоро таймер',
        description:
          'Чередуйте фокус и перерыв по схеме 25/5, 50/10 или со своими интервалами. Настройки сохраняются только в браузере.',
        href: '/pomodoro-tajmer',
      },
      {
        title: 'Секундомер',
        description:
          'Считайте время вверх с отображением миллисекунд. Доступны пауза, сброс, круги и сплиты.',
        href: '/sekundomer',
      },
    ],
  },

  calendar: {
    title: 'Календарь онлайн',
    yearTitle: 'Календарь на {year} год',
    description:
      'Календарь на год и месяц с настройкой начала недели, номерами ISO недель и версией для печати.',
    yearDescription:
      'Календарь на {year} год по месяцам: выбирайте вид на весь год или один месяц, начало недели и номера ISO недель. Версию можно распечатать прямо из браузера.',
    year: 'Год',
    month: 'Месяц',
    view: 'Вид календаря',
    yearView: 'Весь год',
    monthView: 'Один месяц',
    weekStarts: 'Начало недели',
    monday: 'Понедельник',
    sunday: 'Воскресенье',
    showIsoWeeks: 'Показывать номера ISO недель',
    isoWeekShort: 'Нед.',
    isoNote:
      'Номера ISO недель требуют начала недели с понедельника. При включении этой опции календарь автоматически переключается на понедельник.',
    disclaimer:
      'Подсвечиваются только субботы и воскресенья. Праздники и переносы выходных не учитываются.',
    print: 'Печать',
    today: 'Текущий месяц',
    reset: 'Сбросить настройки',
    weekdaysMonday: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    weekdaysSunday: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Учитывает ли календарь официальные праздники?',
        answer:
          'Нет. Календарь подсвечивает только обычные субботы и воскресенья. Праздники, переносы выходных и производственный календарь не входят в этот инструмент.',
      },
      {
        question: 'Что означают номера ISO недель?',
        answer:
          'ISO 8601 считает недели с понедельника. Первая ISO-неделя года содержит первый четверг января, поэтому номер ISO недели на границе года может относиться к соседнему ISO году.',
      },
      {
        question: 'Как распечатать календарь?',
        answer:
          'Выберите годовой или месячный вид и нажмите «Печать». Навигация и настройки будут скрыты в печатной версии браузера.',
      },
    ],
    yearFaq: [
      {
        question: 'Можно ли посмотреть календарь на {year} год по месяцам?',
        answer:
          'Да. На странице календаря {year} года выберите вид «Один месяц», затем нужный месяц. Также доступен обзор всех 12 месяцев на одной странице.',
      },
      {
        question: 'Какие выходные отмечены в календаре {year} года?',
        answer:
          'Подсвечиваются только субботы и воскресенья {year} года. Официальные праздники, переносы выходных и производственный календарь не учитываются.',
      },
      {
        question: 'Как распечатать календарь на {year} год?',
        answer:
          'Выберите годовой или месячный вид и нажмите «Печать». В печатной версии браузера скрываются навигация и настройки календаря.',
      },
    ],
  },

  shiftCalendar: {
    title: 'Календарь сменного графика',
    description:
      'Выберите повторяющийся цикл и первый рабочий день — календарь сразу отметит ваши смены и выходные на весь год.',
    presetTitle: 'График работы',
    presets: {
      '2_2': '2 рабочих / 2 выходных',
      '3_3': '3 рабочих / 3 выходных',
      '1_3': 'Сутки через трое',
      custom: 'Свой цикл',
    },
    customWorkDays: 'Рабочих дней подряд',
    customRestDays: 'Выходных дней подряд',
    firstWorkDate: 'Первый рабочий день цикла',
    year: 'Год календаря',
    shiftHours: 'Часов в одной смене',
    limits: 'Допустимо: год 1900–2100, от 1 до 31 рабочего и выходного дня, от 1 до 24 часов в смене.',
    summaryTitle: 'Итоги за {year} год',
    workShifts: 'Рабочих смен',
    restDays: 'Выходных дней',
    totalHours: 'Часов по заданной длительности',
    workDay: 'Рабочая смена',
    restDay: 'Выходной',
    calendarTitle: 'Календарь на {year} год',
    weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    disclaimerTitle: 'Это персональный циклический график',
    disclaimer:
      'Результат не является федеральным производственным календарём, табелем, графиком работодателя, юридической нормой рабочего времени или расчётом оплаты. Праздники и переносы не меняют цикл автоматически.',
    productionCalendarLink: 'Открыть производственный календарь РФ как справочник',
    privacy:
      'Даты и параметры графика обрабатываются только в браузере, не сохраняются и не передаются в аналитику.',
    errors: {
      invalid_first_work_date: 'Укажите существующую дату первого рабочего дня.',
      unsupported_year: 'Выберите год от 1900 до 2100.',
      invalid_cycle: 'В своём цикле задайте от 1 до 31 рабочего и выходного дня.',
      invalid_shift_hours: 'Продолжительность смены должна быть целым числом от 1 до 24 часов.',
    },
    howTitle: 'Как составить график смен',
    howTo: [
      'Выберите готовый график 2/2, 3/3, сутки через трое или задайте свой простой цикл.',
      'Укажите первый рабочий день цикла и год, который нужно показать.',
      'Задайте продолжительность одной смены для ориентировочного итога в часах.',
      'Сверьте рабочие и выходные дни в календаре; праздники смотрите отдельно в производственном календаре.',
    ],
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Учитываются ли праздники и переносы выходных?',
        answer: 'Нет. Персональный цикл продолжается независимо от суббот, воскресений, праздников и федеральных переносов.',
      },
      {
        question: 'Можно ли использовать календарь как табель или расчёт зарплаты?',
        answer: 'Нет. Это ориентировочный личный календарь повторяющегося цикла, а не документ работодателя, юридическая проверка часов или расчёт оплаты.',
      },
      {
        question: 'Куда отправляются даты моего графика?',
        answer: 'Никуда. Вычисление выполняется локально в браузере; даты, часы и значения своего цикла не попадают в аналитику.',
      },
    ],
  },

  timestamp: {
    title: 'Unix timestamp конвертер',
    description:
      'Конвертируйте Unix timestamp в дату и обратно. Текущее время, секунды, миллисекунды, наносекунды и epoch days. Всё работает локально в браузере.',
    currentUnixTime: 'Текущее Unix время',
    seconds: 'Секунды',
    milliseconds: 'Миллисекунды',
    nanoseconds: 'Наносекунды',
    epochDays: 'Epoch days',
    timestampToDate: 'Timestamp -> дата',
    dateToTimestamp: 'Дата -> timestamp',
    inputPlaceholder: 'Введите timestamp или epoch day',
    now: 'Сейчас',
    detectedFormat: 'Распознан формат',
    secondsFormat: 'секунды',
    millisecondsFormat: 'миллисекунды',
    nanosecondsFormat: 'наносекунды',
    epochDaysFormat: 'epoch days',
    dateTime: 'Дата и время',
    timezone: 'Часовой пояс',
    copyAriaPrefix: 'Скопировать',
    faq: [
      {
        title: 'Что такое Unix timestamp?',
        body:
          'Unix timestamp — это количество времени, прошедшего с 1 января 1970 года (UTC). В API и базах данных он встречается в секундах, миллисекундах, наносекундах или как номер дня от Unix epoch.',
      },
      {
        title: 'Как конвертер определяет формат timestamp?',
        body:
          'Конвертер проверяет, попадает ли число в диапазон 2000-2100 годов как миллисекунды, секунды, наносекунды или epoch days. Это покрывает актуальные значения из JavaScript, JVM, PostgreSQL и других систем.',
      },
      {
        title: 'Когда это полезно',
        body:
          'Отладка API, работа с базами данных, анализ логов, настройка cron задач, конвертация между форматами времени для программирования. Всё работает локально — данные не отправляются на сервер.',
      },
    ],
  },

  addSubtractDate: {
    title: 'Добавить или вычесть дни из даты',
    description:
      'Добавляйте календарные или рабочие дни к выбранной дате. Для рабочих дней доступны обычные выходные и проверенный федеральный календарь РФ.',
    calculationMode: 'Что считать',
    calendarMode: 'Календарный период',
    workingMode: 'Рабочие дни',
    baseDate: 'Исходная дата',
    direction: 'Направление',
    add: 'Добавить',
    subtract: 'Вычесть',
    amount: 'Количество',
    unit: 'Единица',
    units: {
      days: 'дней',
      weeks: 'недель',
      months: 'месяцев',
      years: 'лет',
    },
    calendarBasis: 'Календарь рабочих дней',
    weekendsOnlyBasis: 'Только суббота и воскресенье',
    federalBasis: 'Федеральный календарь РФ, пятидневка',
    weekendsOnlyNote:
      'Рабочими считаются понедельник–пятница. Государственные праздники и переносы не применяются.',
    federalBasisNote:
      'Расчёт использует только утверждённые данные федеральной пятидневки. При непокрытом годе результат полностью отклоняется.',
    quickActions: 'Быстрый выбор',
    presets: {
      week: '+7 дней',
      'two-weeks-back': '-14 дней',
      month: '+1 месяц',
    },
    resultReady: 'Итоговая дата',
    emptyResultTitle: 'Задайте дату и период',
    emptyResultDescription:
      'Выберите исходную дату, направление и количество. Расчёт выполняется локально в браузере.',
    workingEmptyTitle: 'Задайте рабочий период',
    workingEmptyDescription:
      'Выберите направление, количество рабочих дней и календарь, затем запустите один локальный расчёт.',
    workingErrorEyebrow: 'Расчёт не выполнен',
    workingErrorTitle: 'Проверьте условия расчёта',
    finalDate: 'Итоговая дата',
    weekday: 'День недели',
    operation: 'Операция',
    added: 'Добавлено',
    subtracted: 'Вычтено',
    workingExplanation:
      'Исходная дата не считается: найден {amount}-й рабочий день, пропущено нерабочих дней — {skipped}.',
    zeroWorkingExplanation:
      'Количество рабочих дней равно 0, поэтому исходная дата возвращена без изменений. Дни не перебирались.',
    skippedWeekends: 'Пропущено обычных выходных',
    skippedFederal: 'Пропущено праздников и переносов',
    weekendsOnlyGuardrail:
      'Этот режим учитывает только субботу и воскресенье и не делает заявлений о праздниках.',
    federalGuardrail:
      'Справочный результат для федеральной пятидневки. Не учитывает регионы, шестидневку, смены, график работодателя, зарплату и юридические сроки.',
    coverageYear: 'Федеральный календарь РФ: {year}',
    coverageMetadata: 'Статус: {status}. Проверено {date}.',
    openCalendarYear: 'Открыть календарь года',
    noFederalFallback:
      'Частичный результат и автоматический переход на обычные выходные запрещены.',
    useWeekendsOnly: 'Перейти на обычные выходные',
    monthEndNotice:
      'Исходный день отсутствует в целевом месяце, поэтому выбран последний день целевого месяца.',
    localNote:
      'Даты не сохраняются и не отправляются на сервер. Расчёт использует локальную календарную дату браузера.',
    errors: {
      invalidAmount: 'Введите целое число от 0 и больше.',
      invalidWorkingAmount: 'Введите целое число от 0 до 10 000.',
      invalidWorkingInput: 'Укажите существующую дату и целое количество рабочих дней от 0 до 10 000.',
      unsupportedDateRange: 'Расчёт выходит за поддерживаемый диапазон дат 0001–9999.',
      coverageGap: 'Нет утверждённого федерального календаря для годов: {years}.',
      processingFailure: 'Утверждённый календарь неполон. Расчёт остановлен без частичного результата.',
      invalidResult: 'Не удалось получить корректную итоговую дату.',
    },
    howToTitle: 'Как рассчитать дату',
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Как прибавляются дни и недели?',
        answer:
          'Дни считаются как календарные дни от исходной даты. Недели умножаются на 7 календарных дней.',
      },
      {
        question: 'Чем рабочие дни отличаются от календарных?',
        answer:
          'Календарный режим считает каждый день. При положительном N режим рабочих дней не учитывает исходную дату: результатом становится N-й рабочий день после или до неё, а нерабочие дни пропускаются. При N = 0 исходная дата возвращается без изменений.',
      },
      {
        question: 'Какие праздники учитывает федеральный режим?',
        answer:
          'Только утверждённые федеральные праздники и переносы для стандартной пятидневки. Если расчёт пересекает непокрытый год, он полностью отклоняется без частичного ответа и автоматического перехода на обычные выходные.',
      },
      {
        question: 'Что происходит с датами в конце месяца?',
        answer:
          'Для месяцев и лет используется правило последнего дня месяца: 31 января плюс 1 месяц даст 28 или 29 февраля, а не март.',
      },
      {
        question: 'Учитывается ли время суток?',
        answer:
          'Нет. Калькулятор работает только с локальными календарными датами, без часов, минут и часовых поясов.',
      },
      {
        question: 'Данные отправляются на сервер?',
        answer:
          'Нет. Расчёт выполняется локально в браузере, выбранные даты не покидают устройство.',
      },
    ],
    howTo: [
      'Выберите исходную дату.',
      'Выберите календарный период или рабочие дни и направление расчёта.',
      'Введите количество; для рабочих дней выберите обычные выходные или утверждённую федеральную пятидневку.',
      'В календарном режиме результат пересчитывается сразу после изменения полей.',
      'В режиме рабочих дней нажмите «Рассчитать по рабочим дням», затем проверьте итоговую дату и день недели.',
    ],
    relatedTitle: 'Связанные инструменты',
    related: [
      {
        title: 'Рабочие дни между датами',
        description: 'Посчитать рабочие и нерабочие дни в диапазоне.',
        href: '/rabochie-dni-mezhdu-datami',
      },
      {
        title: 'Производственный календарь',
        description: 'Проверить покрытие, источники и календарь федеральной пятидневки.',
        href: '/proizvodstvennyj-kalendar',
      },
      {
        title: 'Разница между датами',
        description: 'Посчитать длительность между двумя датами.',
        href: '/raznica-mezhdu-datami',
      },
    ],
  },

  dateDifference: {
    title: 'Разница между датами в днях и неделях',
    description:
      'Узнайте, сколько дней и недель между двумя датами: общее число недель, полные недели с остатком дней, месяцы и годы.',
    startDate: 'Начальная дата',
    endDate: 'Конечная дата',
    inclusive: 'Включая конечную дату',
    boundaryRuleExclusive:
      'После упорядочивания дат более ранняя граница включена, а более поздняя исключена.',
    boundaryRuleInclusive:
      'После упорядочивания дат обе границы включены: к обычной разнице добавляется один календарный день.',
    businessDaysOnly: 'Только рабочие дни',
    swap: 'Поменять местами',
    quickRanges: 'Быстрые диапазоны',
    settings: 'Настройки расчёта',
    resultReady: 'Итог считается сразу',
    emptyResultTitle: 'Выберите две даты',
    emptyResultDescription:
      'Заполните поля вручную или нажмите быстрый диапазон — результат появится здесь без перезагрузки страницы.',
    calendarDays: 'календарных дней',
    timeline: 'Линия периода',
    approximationHint:
      'Месяцы и годы показаны приблизительно: календарные месяцы имеют разную длину.',
    presetNextWeek: 'Следующие 7 дней',
    presetNextWeekHint: 'Быстро проверить ближайший срок',
    presetWorkSprint: 'Рабочий месяц',
    presetWorkSprintHint: '30 дней с подсчётом будней',
    presetPastWeek: 'Прошлая неделя',
    presetPastWeekHint: 'Включая сегодняшний день',
    swapped: 'Даты поменяны местами — показана абсолютная разница.',
    totalWeeks: 'Всего недель',
    fullWeeksAndDays: 'Полные недели и остаток',
    monthsApprox: 'Месяцев (прибл.)',
    yearsApprox: 'Лет (прибл.)',
    weekShort: 'нед.',
    dayShort: 'дн.',
    businessDays: 'Рабочих дней:',
    howToTitle: 'Как посчитать дни и недели между датами',
    howTo: [
      'Выберите начальную и конечную даты.',
      'После упорядочивания более ранняя дата включена всегда. При необходимости включите более позднюю дату или подсчёт рабочих дней.',
      'Проверьте общее число недель, полные недели с остатком дней и остальные результаты — они обновляются сразу.',
    ],
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Как считается разница?',
        answer:
          'Калькулятор сначала упорядочивает даты. По умолчанию более ранняя дата включена, а более поздняя исключена. Если включена опция «Включая конечную дату», учитываются обе границы. При обратном порядке показывается та же абсолютная разница.',
      },
      {
        question: 'Как посчитать, сколько недель между датами?',
        answer:
          'Калькулятор делит итоговое число календарных дней на 7. Он показывает общее число недель с дробной частью и отдельно — полные недели с остатком дней. Оба результата используют то же правило включения границ, что и итог в днях.',
      },
      {
        question: 'Что такое «рабочие дни»?',
        answer:
          'Рабочие дни — это дни с понедельника по пятницу без учёта субботы и воскресенья. Государственные праздники не учитываются.',
      },
      {
        question: 'Почему месяцы и годы указаны как «приблизительно»?',
        answer:
          'Месяцы имеют разную длину (28-31 день), поэтому разница в месяцах и годах — это приблизительная оценка на основе среднего количества дней.',
      },
      {
        question: 'Данные отправляются на сервер?',
        answer:
          'Нет. Все расчёты выполняются локально в вашем браузере. Даты не покидают ваше устройство.',
      },
    ],
  },

  businessDays: {
    title: 'Рабочие дни между датами',
    description:
      'Посчитайте рабочие дни между датами в режиме обычных выходных или по проверенному федеральному календарю РФ для пятидневки.',
    startDate: 'Начальная дата',
    endDate: 'Конечная дата',
    includeEndDate: 'Включая конечную дату',
    includeEndDateHint:
      'Выключите, если нужно считать период до даты, но не включая последний день.',
    swap: 'Поменять местами',
    quickRanges: 'Быстрые диапазоны',
    quickThisWeek: 'Эта неделя',
    quickThisWeekHint: 'Понедельник-воскресенье текущей недели',
    quickTwoWeeks: 'Следующие 14 дней',
    quickTwoWeeksHint: 'Две недели от сегодняшней даты',
    quickMonth: 'Следующие 30 дней',
    quickMonthHint: 'Рабочий ориентир на месяц вперёд',
    resultReady: 'Итог считается сразу',
    emptyResultTitle: 'Выберите две даты',
    emptyResultDescription:
      'Заполните начальную и конечную дату — справа появятся календарные дни, будни и выходные.',
    calendarDays: 'Календарных дней',
    workingDays: 'Рабочих дней',
    workingDaysLower: 'рабочих дней',
    ordinaryWeekendDays: 'Обычных выходных',
    federalHolidayDays: 'Федеральных праздников / переносов',
    timeline: 'Линия периода',
    calendarMode: 'Режим календаря',
    weekendsOnlyMode: 'Только суббота и воскресенье',
    federalMode: 'Федеральный календарь РФ, пятидневка',
    weekendsOnlyNote:
      'Калькулятор считает рабочими дни с понедельника по пятницу. Государственные праздники, переносы и региональные календари не учитываются.',
    federalModeNote:
      'Режим использует только approved-данные федерального календаря РФ для стандартной пятидневки и требует полного покрытия всех лет диапазона.',
    noHolidayGuarantee:
      'Это справочный weekends-only расчёт. Для зарплаты, отпусков, договорных сроков и юридических дедлайнов сверьтесь с календарём работодателя и официально опубликованными актами.',
    federalGuardrail:
      'Справочный расчёт не учитывает региональные праздники, шестидневку, сменные и индивидуальные графики. Это не гарантия для зарплаты, кадрового учёта или юридических сроков: сверяйтесь с календарём работодателя, региональными актами и официальным законодательством.',
    coverageErrorEyebrow: 'Нет полного approved-покрытия',
    coverageErrorTitle: 'Федеральный режим не может посчитать диапазон',
    coverageErrorDescription:
      'Для всех лет диапазона нужны проверенные данные. Нет approved-календаря для: {years}.',
    noFallback:
      'Частичный результат и автоматический переход к обычным выходным отключены, чтобы не показывать неточный расчёт.',
    useWeekendsOnly: 'Осознанно выбрать только субботу и воскресенье',
    coverageYear: 'Покрытие за {year} год',
    coverageMetadata: 'Федеральная пятидневка · статус {status} · Проверено {date}',
    openCalendarYear: 'Открыть календарь года →',
    productionCalendarTitle: 'Производственный календарь РФ',
    productionCalendarDescription:
      'Посмотрите источники, федеральные праздники и переносы для опубликованных approved-лет стандартной пятидневки.',
    swapped: 'Даты поменяны местами — показан абсолютный период.',
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Как считаются рабочие дни между датами?',
        answer:
          'Калькулятор проходит по календарным датам в выбранном периоде и считает буднями понедельник-пятницу. Суббота и воскресенье попадают в выходные.',
      },
      {
        question: 'Учитываются ли праздники и переносы выходных?',
        answer:
          'По умолчанию нет: выбран режим «Только суббота и воскресенье». Отдельный режим федерального календаря РФ учитывает approved-праздники и переносы для стандартной пятидневки только при полном покрытии всех лет диапазона.',
      },
      {
        question: 'Включается ли конечная дата?',
        answer:
          'По умолчанию конечная дата включается. Если нужно считать период до даты, но не включая её, выключите опцию «Включая конечную дату».',
      },
      {
        question: 'Можно ли использовать результат для расчёта зарплаты или юридического срока?',
        answer:
          'Нет. Это справочный калькулятор без гарантии для payroll, отпусков, договорных сроков и юридических дедлайнов.',
      },
      {
        question: 'Данные отправляются на сервер?',
        answer:
          'Нет. Все расчёты выполняются локально в браузере, выбранные даты не отправляются на сервер.',
      },
    ],
    howTo: [
      'Выберите начальную дату.',
      'Выберите конечную дату.',
      'Выберите режим: только суббота и воскресенье либо федеральный календарь РФ для пятидневки.',
      'Оставьте включённой опцию конечной даты или выключите её для расчёта до даты.',
      'Проверьте календарные, рабочие, обычные выходные и федеральные праздничные дни — результат обновляется сразу.',
    ],
    relatedTitle: 'Связанные инструменты для дат',
    related: [
      {
        title: 'Разница между датами',
        description: 'Посчитать дни, недели, месяцы и общую длительность между двумя датами.',
        href: '/raznica-mezhdu-datami',
      },
      {
        title: 'Сколько дней до даты',
        description: 'Узнать, сколько календарных дней осталось до выбранной даты.',
        href: '/skolko-dnej-do-daty',
      },
      {
        title: 'Номер недели',
        description: 'Получить ISO неделю, ISO год и диапазон понедельник-воскресенье.',
        href: '/nomer-nedeli',
      },
    ],
  },

  ageCalculator: {
    title: 'Калькулятор возраста',
    description:
      'Посчитайте точный возраст по дате рождения: полные годы, месяцы, дни и всего прожитых дней. Целевая дата необязательна — по умолчанию используется сегодня.',
    birthDate: 'Дата рождения',
    targetDate: 'Дата расчёта',
    targetDateHint: 'Необязательно: оставьте пустым, чтобы считать на сегодня.',
    useToday: 'Сегодня',
    hintTitle: 'Как считается возраст',
    hintDescription:
      'Калькулятор считает полные календарные годы, затем месяцы и оставшиеся дни между датой рождения и датой расчёта.',
    resultReady: 'Результат',
    emptyResultTitle: 'Введите дату рождения',
    emptyResultDescription:
      'Укажите дату рождения и при необходимости дату расчёта — результат появится сразу.',
    years: 'Лет',
    months: 'Месяцев',
    days: 'Дней',
    period: 'Период расчёта',
    totalDays: 'Всего дней',
    nextBirthday: 'Дней до дня рождения',
    nextBirthdayHint: 'Следующий день рождения: {date}.',
    relatedTitle: 'Связанные инструменты для дат',
    related: [
      {
        title: 'Разница между датами',
        description: 'Посчитать дни, недели, месяцы и рабочие дни между двумя датами.',
        href: '/raznica-mezhdu-datami',
      },
      {
        title: 'Unix timestamp конвертер',
        description: 'Перевести дату в Unix timestamp или timestamp обратно в дату.',
        href: '/timestamp',
      },
      {
        title: 'Секундомер',
        description: 'Засечь время с миллисекундами прямо в браузере.',
        href: '/sekundomer',
      },
    ],
    errors: {
      missing_birth_date: 'Укажите дату рождения.',
      invalid_birth_date: 'Дата рождения некорректна.',
      invalid_target_date: 'Дата расчёта некорректна.',
      future_birth_date: 'Дата рождения не может быть в будущем.',
      future_target_date: 'Дата расчёта не может быть в будущем.',
      target_before_birth: 'Дата расчёта не может быть раньше даты рождения.',
    },
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Как считается возраст?',
        answer:
          'Сначала считаются полные календарные годы от даты рождения, затем полные месяцы после последнего дня рождения и оставшиеся дни.',
      },
      {
        question: 'Что означает «всего дней»?',
        answer:
          'Это количество календарных дней между датой рождения и датой расчёта. Если дата расчёта не указана, используется сегодняшняя дата.',
      },
      {
        question: 'Можно ли выбрать дату в будущем?',
        answer:
          'Нет. Калькулятор показывает ошибку для будущей даты рождения или даты расчёта, чтобы не смешивать текущий возраст с прогнозом.',
      },
      {
        question: 'Данные отправляются на сервер?',
        answer:
          'Нет. Все расчёты выполняются локально в браузере, даты не покидают ваше устройство.',
      },
    ],
    howTo: [
      'Введите дату рождения.',
      'При необходимости укажите дату расчёта; если оставить поле пустым, используется сегодня.',
      'Сразу проверьте возраст в годах, месяцах и днях, а также общее число прожитых дней.',
    ],
  },

  daysUntilDate: {
    title: 'Сколько дней до даты',
    description:
      'Выберите дату и узнайте, сколько дней и недель осталось. Калькулятор сразу показывает, дата сегодня, уже прошла или впереди.',
    targetDate: 'Целевая дата',
    label: 'Название события',
    labelPlaceholder: 'Например: отпуск, релиз, день рождения',
    quickDates: 'Быстрый выбор',
    quickWeek: 'Через 7 дней',
    quickMonth: 'Через 30 дней',
    quickYear: 'Через год',
    resultReady: 'Итог считается сразу',
    emptyResultTitle: 'Выберите целевую дату',
    emptyResultDescription:
      'Дата и название события остаются только в браузере. Результат появится здесь без отправки данных на сервер.',
    calendarDays: 'календарных дней',
    daysRemaining: 'Дней до даты',
    weeksRemaining: 'Недель до даты',
    weeksApprox: 'Недель (прибл.)',
    status: 'Статус даты',
    statusFuture: 'Дата впереди',
    statusToday: 'Сегодня',
    statusPast: 'Дата уже прошла',
    timeline: 'Линия отсчёта',
    today: 'Сегодня',
    targetPrefix: 'Целевая дата:',
    labelPrefix: 'Событие',
    localNote:
      'Название события не сохраняется и не отправляется на сервер. После очистки или закрытия вкладки оно исчезнет.',
    weekShort: 'нед.',
    dayShort: 'дн.',
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Как считается «сколько дней до даты»?',
        answer:
          'Калькулятор сравнивает выбранную дату с сегодняшним днём в вашем браузере и показывает разницу в календарных днях.',
      },
      {
        question: 'Что показывает статус даты?',
        answer:
          'Если разница положительная, дата впереди. Если ноль — это сегодня. Если значение отрицательное, выбранная дата уже прошла.',
      },
      {
        question: 'Сохраняется ли название события?',
        answer:
          'Нет. Название нужно только для подписи результата на странице, не сохраняется в localStorage и не отправляется на сервер.',
      },
      {
        question: 'Учитываются ли часовые пояса?',
        answer:
          'Расчёт идёт по локальной календарной дате браузера. Время суток не используется.',
      },
    ],
    howTo: [
      'Выберите целевую дату в календарном поле.',
      'При необходимости добавьте название события — оно останется только на странице.',
      'Используйте быстрый выбор даты или посмотрите дни, недели и статус сразу после ввода.',
    ],
    relatedTitle: 'Связанные инструменты',
    related: [
      {
        title: 'Разница между датами',
        description: 'Сравнить две произвольные даты и посчитать рабочие дни.',
        href: '/raznica-mezhdu-datami',
      },
      {
        title: 'Таймер',
        description: 'Запустить обратный отсчёт в часах, минутах и секундах.',
        href: '/timer',
      },
      {
        title: 'Unix timestamp конвертер',
        description: 'Перевести дату и время в Unix timestamp и обратно.',
        href: '/timestamp',
      },
    ],
  },

  weekNumber: {
    title: 'Номер недели',
    description:
      'Узнайте номер ISO недели по дате, ISO год и день недели. Можно также ввести ISO год и номер недели, чтобы получить диапазон дат с понедельника по воскресенье.',
    dateLabel: 'Дата',
    isoYearLabel: 'ISO год',
    isoWeekLabel: 'ISO неделя',
    dateDirectionTitle: 'Дата → ISO неделя',
    rangeDirectionTitle: 'ISO неделя → диапазон дат',
    reactiveHint: 'Результат обновляется сразу после полного корректного ввода.',
    copyDateToIso: 'Скопировать в ISO поля',
    copyIsoToDate: 'Установить дату понедельника',
    today: 'Сегодня',
    resultTitle: 'ISO неделя по дате',
    weekUnit: 'неделя ISO',
    isoYear: 'ISO год',
    weekday: 'День недели',
    isoWeekday: 'Номер дня',
    rangeTitle: 'Диапазон недели',
    weekStart: 'Пн',
    weekEnd: 'Вс',
    emptyDateTitle: 'Выберите дату',
    emptyDateDescription:
      'Введите дату в календарном поле — номер ISO недели, год и день недели появятся здесь.',
    emptyRangeDescription:
      'Введите ISO год и неделю от 1 до 52 или 53. Диапазон недели появится здесь.',
    dateCopied: 'ISO год и неделя скопированы в соседний блок.',
    rangeCopied: 'Дата установлена на понедельник выбранной ISO недели.',
    invalidDate: 'Введите корректную дату.',
    invalidIsoWeek: 'Введите существующую ISO неделю для выбранного года.',
    newYearTitle: 'Почему ISO год может отличаться',
    newYearDescription:
      'ISO неделя всегда начинается в понедельник, а первая неделя ISO года — та, где есть первый четверг января. Поэтому 1 января иногда относится к последней неделе прошлого ISO года, а 31 декабря — к первой неделе следующего.',
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Что такое ISO номер недели?',
        answer:
          'Это номер недели по ISO 8601: недели начинаются в понедельник, а первая неделя года содержит первый четверг января.',
      },
      {
        question: 'Почему дата в январе может быть в прошлом ISO году?',
        answer:
          'Если первые дни января попадают до первой ISO недели, они относятся к последней ISO неделе предыдущего года.',
      },
      {
        question: 'Может ли в году быть 53 недели?',
        answer:
          'Да. В некоторых ISO годах есть 53 недели, если календарь года начинается или заканчивается так, что появляется полная дополнительная ISO неделя.',
      },
      {
        question: 'Данные отправляются на сервер?',
        answer:
          'Нет. Расчёт номера недели и диапазона выполняется локально в браузере.',
      },
    ],
    howTo: [
      'Введите дату — ISO неделя, ISO год и день недели появятся сразу.',
      'Отдельно введите ISO год и номер недели — диапазон понедельник-воскресенье обновится сразу.',
      'При необходимости явно скопируйте результат одного блока во входные поля другого.',
    ],
    relatedTitle: 'Связанные инструменты',
    related: [
      {
        title: 'Разница между датами',
        description: 'Посчитать дни, недели и рабочие дни между двумя датами.',
        href: '/raznica-mezhdu-datami',
      },
      {
        title: 'Сколько дней до даты',
        description: 'Узнать, сколько дней и недель осталось до выбранной даты.',
        href: '/skolko-dnej-do-daty',
      },
      {
        title: 'Unix timestamp конвертер',
        description: 'Перевести дату и время в Unix timestamp и обратно.',
        href: '/timestamp',
      },
    ],
  },

  timer: {
    title: 'Таймер',
    description:
      'Запустите таймер с часами, минутами и секундами прямо в браузере. Без регистрации и установки приложения.',
    hours: 'Часы',
    minutes: 'Минуты',
    seconds: 'Секунды',
    start: 'Старт',
    pause: 'Пауза',
    reset: 'Сброс',
    quickAddLabel: 'Добавить время',
    quickAddMinuteShort: 'мин',
    timerHint: 'Задайте время и запустите обратный отсчёт.',
    doneNotice: 'Время вышло. Прозвучал сигнал завершения.',
    invalidDuration: 'Укажите время больше нуля.',
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Нужна ли регистрация?',
        answer:
          'Нет. Откройте страницу, задайте время и запустите таймер — аккаунт не нужен.',
      },
      {
        question: 'Работает ли таймер без сервера?',
        answer:
          'Да. Отсчёт выполняется локально в браузере. Данные не уходят на сервер, истории и напоминаний нет.',
      },
      {
        question: 'Будет ли звук в конце таймера?',
        answer:
          'Да, при завершении таймера браузер проигрывает короткий звуковой сигнал. Если звук в браузере или системе выключен, сигнал может быть не слышен.',
      },
      {
        question: 'Обновляется ли заголовок вкладки?',
        answer:
          'Да. Пока таймер работает, в заголовке вкладки показывается оставшееся время.',
      },
    ],
    howTo: [
      'Укажите часы, минуты и секунды для обратного отсчёта.',
      'При необходимости добавьте +1, +5 или +10 минут быстрыми кнопками.',
      'Нажмите «Старт»: отсчёт начнётся сразу, а заголовок вкладки покажет оставшееся время.',
      'Используйте «Пауза» и «Сброс». В конце таймера прозвучит короткий сигнал.',
    ],
    relatedTitle: 'Связанные инструменты',
    related: [
      { title: 'Помодоро таймер', description: 'Чередовать фокус и перерывы по интервалам.', href: '/pomodoro-tajmer' },
      { title: 'Секундомер', description: 'Считать время вверх и сохранять круги.', href: '/sekundomer' },
    ],
  },

  pomodoro: {
    title: 'Помодоро таймер',
    description:
      'Локальный интервальный таймер для фокусировки: 25/5, 50/10 или свои длительности работы и перерыва. Без аккаунта и отправки данных на сервер.',
    focus: 'Фокус',
    break: 'Перерыв',
    status: {
      idle: 'Готов',
      running: 'Идёт',
      paused: 'Пауза',
      completed: 'Фаза завершена',
    },
    cycles: 'Завершено фокус-сессий',
    start: 'Старт',
    resume: 'Продолжить',
    pause: 'Пауза',
    reset: 'Сброс',
    presets: 'Готовые интервалы',
    custom: 'Свои длительности',
    focusMinutes: 'Фокус, минут',
    breakMinutes: 'Перерыв, минут',
    alerts: 'Сигналы завершения',
    sound: 'Звук',
    vibration: 'Вибрация',
    enableNotifications: 'Разрешить уведомления браузера',
    disableNotifications: 'Выключить уведомления браузера',
    notificationsEnabled: 'Уведомления включены.',
    notificationsDisabled: 'Уведомления выключены.',
    notificationsDenied: 'Браузер не разрешил уведомления.',
    notificationsUnavailable: 'Этот браузер не поддерживает уведомления.',
    notificationTitle: 'Помодоро: фаза завершена',
    alertsHint: 'Все сигналы включаются только вами. Уведомления запрашиваются отдельной кнопкой и не появляются без разрешения.',
    accuracyHint: 'Таймер сверяется с абсолютным временем при возврате во вкладку.',
    focusDone: 'Фокус завершён. Перерыв подготовлен — запустите его, когда будете готовы.',
    breakDone: 'Перерыв завершён. Следующая фокус-сессия подготовлена.',
    invalidDuration: 'Укажите целые длительности: фокус 1–180 минут, перерыв 1–60 минут.',
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Как работает техника Помодоро?',
        answer: 'Вы выбираете интервал фокусировки и перерыв. После завершения каждой фазы таймер готовит следующую, но не запускает её автоматически.',
      },
      {
        question: 'Продолжит ли таймер считать в фоновой вкладке?',
        answer: 'Да, оставшееся время вычисляется по абсолютному сроку и сверяется при возврате во вкладку. Однако мобильный браузер или сон устройства могут задержать звук и уведомление, поэтому это не замена будильнику.',
      },
      {
        question: 'Что сохраняется в браузере?',
        answer: 'Только выбранные длительности и настройки сигналов. Активный отсчёт, дедлайн и история циклов не сохраняются.',
      },
      {
        question: 'Нужны ли аккаунт или сервер?',
        answer: 'Нет. Таймер работает локально в браузере, без регистрации, задач, статистики и отправки настроек на сервер.',
      },
    ],
    howTo: [
      'Выберите готовый интервал 25/5 или 50/10 либо задайте свои длительности.',
      'При желании явно включите звук, вибрацию или разрешите уведомления браузера.',
      'Нажмите «Старт», чтобы начать фокус-сессию; пауза и продолжение сохраняют текущий интервал.',
      'После завершения фокуса запустите подготовленный перерыв вручную.',
    ],
    relatedTitle: 'Связанные инструменты',
    related: [
      { title: 'Обычный таймер', description: 'Запустить разовый обратный отсчёт.', href: '/timer' },
      { title: 'Секундомер', description: 'Считать время вверх и сохранять круги.', href: '/sekundomer' },
    ],
  },

  stopwatch: {
    title: 'Онлайн-секундомер с миллисекундами',
    description:
      'Запускайте и ставьте секундомер на паузу, сбрасывайте отсчёт и фиксируйте круги со сплитами. Миллисекунды отображаются прямо в браузере.',
    start: 'Старт',
    pause: 'Пауза',
    reset: 'Сброс',
    lap: 'Круг',
    lapsTitle: 'Отсечки кругов',
    total: 'Всего',
    split: 'Сплит',
    copyLaps: 'Копировать круги',
    copyFailed: 'Не скопировалось',
    hint: 'Старт и пауза управляют отсчётом, «Круг» сохраняет отсечку, а «Сброс» начинает новую сессию.',
    accuracyTitle: 'Как работает точность секундомера',
    accuracyDescription:
      'Время считается по монотонным часам браузера, а экран обновляется через animation frame. В фоновой вкладке отрисовка может замедлиться или остановиться; после возврата значение пересчитывается по часам браузера. Сон устройства и ограничения конкретного браузера остаются вне гарантий, поэтому это не лабораторный измерительный прибор.',
    howTitle: 'Как пользоваться секундомером',
    faqTitle: 'Часто задаваемые вопросы',
    faq: [
      {
        question: 'Секундомер работает локально?',
        answer:
          'Да. Отсчёт выполняется в браузере, без отправки данных на сервер.',
      },
      {
        question: 'Показываются ли миллисекунды?',
        answer:
          'Да. Основной экран и заголовок вкладки отображают часы, минуты, секунды и миллисекунды. Это формат отображения, а не обещание лабораторной точности.',
      },
      {
        question: 'Что происходит в фоновой вкладке?',
        answer:
          'Браузер может замедлить или остановить обновление экрана. После возврата секундомер пересчитывает значение по монотонным часам браузера; сон устройства и ограничения браузера могут повлиять на результат.',
      },
      {
        question: 'Можно ли поставить секундомер на паузу?',
        answer:
          'Да. Используйте «Пауза» или пробел, чтобы остановить счёт, и «Старт» или пробел, чтобы продолжить с того же значения.',
      },
      {
        question: 'Можно ли сохранять круги?',
        answer:
          'Да. Нажмите «Круг» или клавишу L, чтобы зафиксировать время и увидеть сплит от предыдущей отсечки. Кнопка «Копировать круги» сохранит таблицу в буфер обмена.',
      },
      {
        question: 'Нужна ли регистрация?',
        answer:
          'Нет. Секундомер доступен сразу после открытия страницы.',
      },
    ],
    howTo: [
      'Нажмите «Старт», чтобы начать отсчёт с отображением миллисекунд.',
      'Нажимайте «Круг», чтобы сохранять общее время и сплит от предыдущей отсечки.',
      'Нажмите «Пауза», чтобы остановить отсчёт, и «Старт», чтобы продолжить с того же значения.',
      'Нажмите «Сброс», чтобы очистить время и круги и начать новую сессию.',
    ],
    relatedTitle: 'Связанные инструменты',
    related: [
      { title: 'Помодоро таймер', description: 'Чередовать фокус и перерывы по интервалам.', href: '/pomodoro-tajmer' },
      { title: 'Обычный таймер', description: 'Запустить разовый обратный отсчёт.', href: '/timer' },
    ],
  },

  timeZones: {
    title: 'Конвертер часовых поясов',
    description:
      'Задайте дату, время и исходную IANA-зону, чтобы сравнить один точный момент в 2–5 городах. Расчёт учитывает смещение UTC и переходы на летнее время.',
    sourceDate: 'Исходная дата',
    sourceTime: 'Исходное время',
    sourceZone: 'Исходный часовой пояс',
    comparisonTitle: 'Время в выбранных зонах',
    comparisonHint: 'Все строки показывают один и тот же момент времени.',
    copyLink: 'Скопировать ссылку для совместного использования',
    addZone: 'Добавить город или IANA-зону',
    searchPlaceholder: 'Например, Нью-Йорк или America/New_York',
    searchHint: 'Поиск использует русские и английские названия популярных городов. Источником истины остаётся IANA ID; неоднозначные CST и IST не принимаются.',
    add: 'Добавить',
    remove: 'Удалить зону',
    moveUp: 'Переместить выше',
    moveDown: 'Переместить ниже',
    gapTitle: 'Такого местного времени не существует.',
    gapDescription: 'В этот момент произошло изменение смещения UTC, поэтому такого местного времени нет (например, при переходе на летнее время). Выберите время до или после перехода.',
    invalidInput: 'Проверьте дату, время и IANA-зону.',
    foldTitle: 'Это время встречается дважды',
    foldDescription: 'При переводе часов назад возникают два разных момента с одинаковым местным временем. Выберите нужный вариант.',
    earlier: 'Первый момент (раньше)',
    later: 'Второй момент (позже)',
    howTitle: 'Как сравнить часовые пояса',
    howTo: [
      'Выберите исходные дату, время и IANA-часовой пояс.',
      'Добавьте от двух до пяти городов или зон для сравнения.',
      'Если время попало на осенний перевод часов назад, выберите первый или второй момент.',
      'Проверьте локальную дату, время и смещение UTC в каждой строке или скопируйте ссылку для совместного использования результата.',
    ],
    accuracyTitle: 'Откуда берутся правила часовых поясов',
    accuracyDescription:
      'Конвертер работает локально через базу часовых поясов браузера. Она учитывает известные правила перехода на летнее время, но может отставать от самых свежих политических изменений. Поэтому результат не является гарантией вечной официальной точности.',
    faqTitle: 'Частые вопросы',
    faq: [
      {
        question: 'Учитывается ли переход на летнее время?',
        answer: 'Да. Смещение определяется для выбранной даты. Несуществующее весеннее время отклоняется, а для повторяющегося осеннего времени можно явно выбрать первый или второй момент.',
      },
      {
        question: 'Можно ли ввести CST или IST?',
        answer: 'Нет. Такие сокращения неоднозначны. Используйте IANA-зону, например America/Chicago или Asia/Kolkata.',
      },
      {
        question: 'Данные отправляются на сервер?',
        answer: 'Нет. Все вычисления выполняются в браузере. Ссылка для совместного использования содержит только выбранные дату, время и IANA-зоны.',
      },
      {
        question: 'Почему дата в другой зоне изменилась?',
        answer: 'Один и тот же момент может приходиться на предыдущий или следующий календарный день в зависимости от смещения UTC выбранной зоны.',
      },
    ],
  },

  blog: {
    breadcrumb: 'Блог',
    title: 'Блог dateify',
    description:
      'Практические заметки про даты, дедлайны, timestamp, рабочие дни и локальные расчёты в браузере.',
    languageAria: 'Язык статей',
    postLanguageAria: 'Язык статьи',
    empty: 'На этом языке пока нет записей.',
    notFoundTitle: 'Пост не найден',
    notFoundDescription: 'Такой заметки в блоге dateify нет или ссылка устарела.',
    relatedTools: 'Связанные инструменты',
    relatedToolDescription: {
      timestamp: 'Конвертация Unix timestamp в дату и обратно.',
      dateDifference: 'Дни, недели, месяцы и рабочие дни между датами.',
      timeZones: 'Сравнение даты и времени в 2–5 городах с учётом переходов часов.',
    },
    localeName: {
      ru: 'Русский',
      en: 'English',
    },
  },

  seo: {
    index: {
      title: 'Инструменты для работы с датами онлайн бесплатно — dateify.ru',
      description:
        'Бесплатные локальные инструменты для работы с датами и временем: Unix timestamp конвертер, разница между датами и другие инструменты для дат. Без регистрации и отправки данных на сервер.',
    },
    calendar: {
      title: 'Календарь онлайн на год и месяц — dateify.ru',
      description:
        'Бесплатный календарь онлайн на год или месяц. Начало недели с понедельника или воскресенья, номера ISO недель и версия для печати. Без праздников и переносов.',
    },
    calendar2026: {
      title: 'Календарь 2026 на год и по месяцам — dateify.ru',
      description:
        'Календарь на 2026 год по месяцам: начало недели с понедельника или воскресенья, номера ISO недель и печать. Подсвечиваются только выходные суббота и воскресенье.',
    },
    calendar2027: {
      title: 'Календарь 2027 на год и по месяцам — dateify.ru',
      description:
        'Календарь на 2027 год по месяцам: начало недели с понедельника или воскресенья, номера ISO недель и печать. Подсвечиваются только выходные суббота и воскресенье.',
    },
    shiftCalendar: {
      title: 'График смен 2/2, 3/3 и сутки через трое — dateify.ru',
      description:
        'Составьте календарь смен на год по циклу 2/2, 3/3, сутки через трое или своему графику. Смены, выходные и часы считаются локально в браузере.',
    },
    timestamp: {
      title: 'Unix timestamp конвертер онлайн — dateify.ru',
      description:
        'Конвертируйте Unix timestamp в дату и обратно. Текущее Unix время, секунды, миллисекунды, наносекунды и epoch days. Бесплатно, без регистрации, локально в браузере.',
    },
    addSubtractDate: {
      title: 'Прибавить дни к дате онлайн: какая дата будет — dateify.ru',
      description:
        'Прибавьте или вычтите дни, недели, месяцы и годы и сразу узнайте итоговую дату и день недели. Есть режим рабочих дней с календарём РФ. Бесплатно.',
    },
    dateDifference: {
      title: 'Разница между датами: сколько дней и недель — dateify.ru',
      description:
        'Сколько дней и недель между двумя датами: результат сразу, полные недели с остатком, месяцы и годы. Без регистрации, считается в браузере.',
    },
    businessDays: {
      title: 'Сколько рабочих дней между датами — калькулятор — dateify.ru',
      description:
        'Сколько рабочих дней между двумя датами: только выходные или производственный календарь РФ с праздниками и переносами. Результат сразу, бесплатно.',
    },
    ageCalculator: {
      title: 'Калькулятор возраста онлайн — сколько лет, месяцев и дней — dateify.ru',
      description:
        'Посчитайте возраст по дате рождения: полные годы, месяцы, дни и всего прожитых дней. Бесплатный калькулятор возраста работает локально в браузере без регистрации.',
    },
    daysUntilDate: {
      title: 'Сколько дней до даты — посчитать онлайн — dateify.ru',
      description:
        'Сколько дней и недель осталось до нужной даты: выберите день и сразу увидите ответ. Покажет и сколько прошло, если дата позади. Бесплатно, без регистрации.',
    },
    weekNumber: {
      title: 'Номер недели по дате — ISO week онлайн — dateify.ru',
      description:
        'Узнайте номер ISO недели, ISO год и день недели по дате или получите диапазон дат по ISO году и номеру недели. Бесплатно, локально в браузере.',
    },
    timeZones: {
      title: 'Конвертер часовых поясов онлайн — время в разных городах — dateify.ru',
      description:
        'Сравните точное время и дату в 2–5 часовых поясах по IANA-зонам. Конвертер учитывает переходы на летнее время, работает локально в браузере и позволяет поделиться ссылкой для совместного использования.',
    },
    timer: {
      title: 'Таймер онлайн бесплатно — dateify.ru',
      description:
        'Запустите таймер с часами, минутами и секундами прямо в браузере. Бесплатно, без регистрации и установки приложения.',
    },
    pomodoro: {
      title: 'Помодоро таймер онлайн — 25/5 и 50/10 — dateify.ru',
      description:
        'Бесплатный Pomodoro таймер для фокусировки: интервалы 25/5, 50/10 и свои длительности. Работает локально в браузере, без регистрации.',
    },
    stopwatch: {
      title: 'Секундомер онлайн с миллисекундами — dateify.ru',
      description:
        'Секундомер онлайн с миллисекундами: старт и пауза пробелом, круги и сплиты, копирование результатов. Работает в браузере, бесплатно и без регистрации.',
    },
    blog: {
      title: 'Блог dateify - заметки про даты и время',
      description:
        'Практические заметки про расчёт дат, Unix timestamp, дедлайны, рабочие дни и локальные date/time инструменты в браузере.',
    },
  },
}

export type Translations = typeof ruTranslations
